import TotalPrice from './TotalPrice';

export default TotalPrice;